import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackButtonClick } from './tracking';
import { getIsFavourite, getNewbuildingId } from '../../selectors/newbuildingHeader';
import { setNewbuildingFavorite } from '../../serp/state/newbuilding_info';
import { TThunkDispatch } from '../../types/redux';

interface INewbuildingHeaderFavouriteButtonContainer {
  button: React.ComponentType<IFavouriteButtonProps>;
}

export interface IFavouriteButtonProps {
  onClick(): void;
  isFavorite: boolean;
}

export const NewbuildingHeaderFavouriteButtonContainer: React.FC<INewbuildingHeaderFavouriteButtonContainer> = ({
  button: FavoriteButton,
}) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const isFavorite = useSelector(getIsFavourite);
  const id = useSelector(getNewbuildingId);

  const handleClick = React.useCallback(() => {
    if (isFavorite !== undefined && id !== undefined) {
      dispatch(setNewbuildingFavorite(!isFavorite, id));

      trackButtonClick({ isFavorite: !isFavorite, newbuildingId: id });
    }
  }, [isFavorite, id, dispatch]);

  if (isFavorite !== undefined) {
    return <FavoriteButton isFavorite={isFavorite} onClick={handleClick} />;
  }

  return null;
};
